import angular from "angular";
import organization from "../organization";
import core from "../../core/core.module";
import fileUpload from "ng-file-upload";

angular
    .module('organizationsControl.organizationForm', [organization, core, fileUpload])
    .component('organizationForm', {
        controller: ['Organization', 'notifier', 'notify', '$http', 'Upload', '$uibModal', controller],
        template: require('./organization-form.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

require('../organization-files-form/organization-files-form');

function controller(Organization, notifier, notify, $http, Upload, $uibModal) {

    let $ctrl = this;

    $ctrl.step = 1;
    $ctrl.inviteEmail = null;
    $ctrl.secret = null;

    $ctrl.$onInit = function () {

        $ctrl.mode = 'create';
        $ctrl.id = null;
        $ctrl.fullName = null;
        $ctrl.shortName = null;
        $ctrl.bin = null;
        $ctrl.minimumBalance = 0;
        $ctrl.nds = null;
        $ctrl.kkm = null;
        $ctrl.isActive = true;
        $ctrl.enableClientsModule = false;
        $ctrl.emails = [];
        $ctrl.phones = [];

        if ($ctrl.resolve.organization) {
            $ctrl.mode = 'editing';

            let org = $ctrl.resolve.organization;

            $ctrl.id = org.id;
            $ctrl.fullName = org.fullName;
            $ctrl.shortName = org.shortName;
            $ctrl.bin = org.bin;
            $ctrl.minimumBalance = org.minimumBalance;
            $ctrl.nds = org.nds;
            $ctrl.kkm = org.kkm;
            $ctrl.isActive = org.isActive;
            $ctrl.enableClientsModule = org.enableClientsModule;
            $ctrl.secret = org.secret;

            org.emails.forEach(function (email) {
                $ctrl.emails.push({value: email});
            });

            org.phones.forEach(function (phone) {
                $ctrl.phones.push({value: phone});
            });
        }

        if (! $ctrl.emails.length) {
            $ctrl.emails = [{value: ''}];
        }

        if (! $ctrl.phones.length) {
            $ctrl.phones = [{value: ''}];
        }
    };

    $ctrl.addEmail = function () {
        $ctrl.emails.push({value: ''});
    };

    $ctrl.delEmail = function (ind) {
        $ctrl.emails.splice(ind, 1);
    };

    $ctrl.addPhone = function () {
        $ctrl.phones.push('');
    };

    $ctrl.delPhone = function (ind) {
        $ctrl.phones.splice(ind, 1);
    };

    $ctrl.openFilesForm = () => {
        $uibModal
            .open({
                component: 'organizationFilesForm',
                resolve: {
                    organization() {
                        return {
                            id: $ctrl.id
                        }
                    }
                }
            })
            .result
            .then(res => {

            })
    };

    $ctrl.submit = function () {

        let params = {
            fullName: $ctrl.fullName,
            shortName: $ctrl.shortName,
            bin: $ctrl.bin,
            minimumBalance: $ctrl.minimumBalance,
            nds: $ctrl.nds,
            kkm: $ctrl.kkm,
            isActive: $ctrl.isActive,
            emails: $ctrl.emails.filter(v => v.value).map(v => v.value),
            phones: $ctrl.phones.filter(v => v.value).map(v => v.value),
            enableClientsModule: $ctrl.enableClientsModule,
        };

        $ctrl.loading = true;

        let defer = $ctrl.id ? Organization.update($ctrl.id, params) : Organization.store(params);

        defer.then(
            function (response) {
                if ($ctrl.id) {
                    notifier.successNotify('Данные успешно обновились', 2000);
                } else {
                    notifier.successNotify('Организация успешно добавлена', 2000);
                    $ctrl.secret = response.data.secret;
                    $ctrl.id = response.data.id;
                }
                $ctrl.loading = false;
            },
            function (error) {
                $ctrl.loading = false;
                notifier.errorResponseNotify(error);
            }
        );
    };

    $ctrl.copySecret = () => {
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText($ctrl.secret);
        } else {
            let textArea = document.createElement("textarea");
            textArea.value = $ctrl.secret;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            new Promise((res, rej) => {
                document.execCommand('copy') ? res() : rej();
                textArea.remove();
            });
        }

        notify({
            message: 'Скопирован в буфер обмена',
            duration: 2000,
            classes: 'alert-info',
            position: 'right'
        });
    }

    $ctrl.sendInvite = () => {
        $ctrl.inviteLoading = true;

        $http
            .post(`/control-panel/organizations/${$ctrl.id}/send-invite`, {email: $ctrl.inviteEmail})
            .then(res => {
                notify({
                    message: 'Успешно отправлен',
                    duration: 2000,
                    classes: 'alert-success',
                    position: 'center'
                });
            })
            .catch(err => {
                notifier.errorResponseNotify(err);
            })
            .finally(() => {
                $ctrl.inviteLoading = false;
            });
    };

    $ctrl.prevStep = () => {
        $ctrl.step--;
    };

    $ctrl.openSecondStep = () => {
        $ctrl.step++;
    };

}

export default 'organizationsControl.organizationForm';



// WEBPACK FOOTER //
// ./resources/assets/modules/organizations-control/organization-form/organization-form.js